import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getDeals() {
  try {
    const deals = yield call(API.getDeals);
    yield put({
      type: actionTypes.DEALS_GET_SUCCESS,
      deals,
    });
  } catch (error) {
    yield put({
      type: actionTypes.DEALS_GET_ERROR,
      error,
    });
  }
}

export function* getDeal({ dealId }) {
  try {
    const deal = yield call(API.getDeal, dealId);
    if (deal.id) {
      yield put({
        type: actionTypes.DEAL_GET_SUCCESS,
        deal,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_GET_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_GET_ERROR,
      error,
    });
  }
}

export function* createDeal({ deal }) {
  try {
    const result = yield call(API.createDeal, deal);
    if (result.error) {
      yield put({
        type: actionTypes.DEAL_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_CREATE_SUCCESS,
        deal: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_CREATE_ERROR,
      error,
    });
  }
}

export function* updateDeal({ dealId, deal }) {
  try {
    const result = yield call(API.updateDeal, dealId, deal);
    if (result.id) {
      yield put({
        type: actionTypes.DEAL_UPDATE_SUCCESS,
        deal: result,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_UPDATE_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_UPDATE_ERROR,
      error,
    });
  }
}

export function* deleteDeal({ dealId }) {
  try {
    yield call(API.deleteDeal, dealId);
    yield put({
      type: actionTypes.DEAL_DELETE_SUCCESS,
      dealId,
    });
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_DELETE_ERROR,
      error,
    });
  }
}

export function* getDealChanges({ dealId }) {
  try {
    const dealChanges = yield call(API.getDealChanges, dealId);
    yield put({
      type: actionTypes.DEAL_CHANGES_GET_SUCCESS,
      dealChanges,
    });
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_CHANGES_GET_ERROR,
      error,
    });
  }
}

export function* getDealChange({ dealChange }) {
  try {
    const result = yield call(API.getDealChange, dealChange);
    if (result.id) {
      yield put({
        type: actionTypes.DEAL_CHANGE_GET_SUCCESS,
        dealChange: result,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_CHANGE_GET_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_CHANGE_GET_ERROR,
      error,
    });
  }
}

export function* createDealChange({ dealChange }) {
  try {
    const result = yield call(API.createDealChange, dealChange);
    if (result.error) {
      yield put({
        type: actionTypes.DEAL_CHANGE_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_CHANGE_CREATE_SUCCESS,
        dealChange: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_CHANGE_CREATE_ERROR,
      error,
    });
  }
}

export function* updateDealChange({ dealChange }) {
  try {
    const result = yield call(API.updateDealChange, dealChange);
    if (result.error) {
      yield put({
        type: actionTypes.DEAL_CHANGE_UPDATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_CHANGE_UPDATE_SUCCESS,
        dealChange: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_CHANGE_UPDATE_ERROR,
      error,
    });
  }
}

export function* deleteDealChange({ dealChange }) {
  try {
    yield call(API.deleteDealChange, dealChange);
    yield put({
      type: actionTypes.DEAL_CHANGE_DELETE_SUCCESS,
      dealChangeId: dealChange.id,
    });
  } catch (error) {
    yield put({
      type: actionTypes.DEAL_CHANGE_DELETE_ERROR,
      error,
    });
  }
}

export function* getUserDeals({ userId }) {
  try {
    const deals = yield call(API.getUserDeals, userId);
    yield put({
      type: actionTypes.DEALS_USER_GET_SUCCESS,
      deals,
    });
  } catch (error) {
    yield put({
      type: actionTypes.DEALS_USER_GET_ERROR,
      error,
    });
  }
}

export function* getFinalizedDeals({ id }) {
  try {
    const finalizedDeals = yield call(API.getFinalizedDeals, id);
    yield put({
      type: actionTypes.FINALIZED_DEALS_GET_SUCCESS,
      finalizedDeals,
    });
  } catch (error) {
    yield put({
      type: actionTypes.FINALIZED_DEALS_GET_ERROR,
      error,
    });
  }
}

export function* notifyDealChange({ dealChange }) {
  try {
    yield call(API.notifyDealChange, dealChange);
  } catch (error) {}
}

export function* sendEmailToInviteeDealChange({ data }) {
  try {
    yield call(API.sendEmailToInviteeDealChange, data);
  } catch (error) {}
}



// WEBPACK FOOTER //
// src/redux/sagas/deals.js